<app-header [transparent]="transparent" />
<div class="press_release">
    <div class="press_release_top text-center bg_img">
        <ng-container *ngFor="let heading of head">
            <div class="inline_padding2" *ngIf="heading.page === currentPage">
                <div class="press_release_top_heading">
                    <span class="text_style_5">Press Release</span>
                </div>
                <div class="press_release_top_description p-top-16">
                    <span [innerHTML]="heading.page_sub_heading"></span>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="press_release_content">
        <div class="press_release_content_box">
            <ng-container *ngFor="let data of pressReleaseList">
                <div class="press_release_content_box_item z_index_1">
                    <div class="card_2 m-t-_75 m-b-75">
                        <div class="card_2_img" style=" padding: 0; border: 0;background:none;">
                            <img style="border-radius: 20px 20px 0 0;" class="card_2_img_sec"
                                [src]="getPressReleaseImageUrl(data)" alt="img" />
                        </div>
                        <div class="card_2_content">
                            <div class="card_2_content_top">
                                <span class="text_blue_2">{{ data.press_release_date | date: 'dd-MM-yyyy' }} | Press
                                    Release</span>
                            </div>
                            <div class="card_2_content_middle">
                                <div class="card_2_content_middle_title text_lines_2" style="padding-top: 10px;">
                                    <span style="font-size: 15px;" class="text_black_1_res"
                                        [innerHtml]="data.title"></span>
                                </div>
                                <div class="card_2_content_middle_normal text_lines_5 text_align-justify "
                                    style="font-size: 14px;" [innerHtml]="data.description">
                                </div>
                            </div>
                            <div class="card_2_content_bottom">
                                <button type="button" class="rounded-pill text_white_1 button_blue_1"
                                    (click)="goToPressReleaseDetail(data._id)"><span class="button_blue_1_text">Read
                                        More</span> <img class="button_blue_1_text_icon"
                                        src="../../../assets/icons/arrow-right.png" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<app-footer />